import React from 'react';
import { Eye } from 'lucide-react';

const MultipleChoiceQuestion = ({
  question,
  result,
  currentAnswer,
  submittedFirstTime,
  showExplanation,
  canRetry,
  onAnswerChange,
  onToggleExplanation
}) => {
  const isFirstAttemptCorrect = result?.isCorrect;

  return (
    <div className={`border rounded-lg p-4 transition-colors ${!submittedFirstTime ? 'bg-gray-50 border-gray-200 hover:bg-gray-100' :
      isFirstAttemptCorrect ? 'bg-green-50 border-green-200' :
        'bg-red-50 border-red-200'
      }`}>
      <div className="flex items-start justify-between mb-4">
        <p className="font-medium text-gray-800 leading-relaxed flex-1">
          {question.question_number}. {question.question_text || question.question}
        </p>

        <div className="flex items-center ml-4 space-x-2">
          {submittedFirstTime && (
            <span className={`text-xs px-2 py-1 rounded-full ${isFirstAttemptCorrect ? 'bg-green-200 text-green-700' : 'bg-red-200 text-red-700'
              }`}>
              {isFirstAttemptCorrect ? '✓ Correct' : '✗ Incorrect'}
            </span>
          )}
          {submittedFirstTime && (
            <button
              onClick={onToggleExplanation}
              className="text-xs px-2 py-1 rounded-full bg-blue-200 text-blue-700 hover:bg-blue-300 transition-colors flex items-center space-x-1"
            >
              <Eye className="w-3 h-3" />
              <span>Explanation</span>
            </button>
          )}
        </div>
      </div>

      <div className="space-y-2">
        {question.options && question.options.map((opt, idx) => {
          const letter = String.fromCharCode(65 + idx);
          const isSelected = currentAnswer === letter;
          const isDisabled = submittedFirstTime && (isFirstAttemptCorrect || !canRetry);

          return (
            <label
              key={`${question.id}-${letter}`}
              className={`flex items-start space-x-3 cursor-pointer p-3 rounded-lg transition-all ${isDisabled
                ? 'bg-gray-100 border border-gray-200 cursor-not-allowed opacity-60'
                : isSelected
                  ? 'bg-blue-100 border border-blue-300'
                  : 'bg-white border border-gray-200 hover:bg-blue-50 hover:border-blue-200'
                }`}
            >
              <input
                type="radio"
                name={canRetry ? `q${question.id}_retry` : `q${question.id}`}
                value={letter}
                checked={isSelected}
                disabled={isDisabled}
                onChange={() => !isDisabled && onAnswerChange(letter)}
                className="text-blue-600 mt-0.5 flex-shrink-0 disabled:opacity-50"
              />
              <span
                className={`text-sm leading-relaxed ${isSelected ? 'text-blue-800 font-medium' : 'text-gray-700'
                  } ${isDisabled ? 'text-gray-500' : ''}`}
              >
                <strong className="font-semibold">{opt.option_key}.</strong> {opt.option_text}

              </span>
            </label>
          );
        })}
      </div>

      {/* Explanation */}
      {submittedFirstTime && showExplanation && (
        <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
          <div className="text-sm space-y-2">

            {(() => {
              const safeText = (v) => {
                if (v === null || v === undefined) return "";
                if (typeof v === "object") {
                  // nếu là object nhiều đáp án → lấy đúng cái user chọn
                  if (currentAnswer && v[currentAnswer]) return v[currentAnswer];
                  return "";
                }
                return String(v);
              };

              // ❗ ❗ SỬA ĐÚNG LOGIC Ở ĐÂY
              const selectedFeedback =
                result?.explanation ||
                question.feedback?.[currentAnswer] ||       // thử lấy feedback theo A/B/C
                question.feedback?.incorrect ||             // fallback quan trọng
                "";

              const correctAns =
                result?.correct_answer ??
                question.correct_answer ??
                question.answer ??
                null;

              return (
                <>
                  {/* YOUR ANSWER */}
                  <p>
                    <strong>Your answer:</strong>{" "}
                    {safeText(result?.selected) || "No answer"}
                  </p>

                  {/* CORRECT ANSWER */}
                  {isFirstAttemptCorrect && (
                    <p>
                      <strong>Correct answer:</strong>{" "}
                      {safeText(correctAns) || "(Not available)"}
                    </p>
                  )}

                  {/* EXPLANATION */}
                  <div className="pt-2 border-t border-blue-200">
                    <p><strong>Explanation:</strong></p>

                    <p className="text-gray-700">
                      {isFirstAttemptCorrect
                        ? safeText(
                          result?.explanation ||
                          question.feedback?.correct ||
                          "Good job!"
                        )
                        : safeText(selectedFeedback) ||
                        "Please review the explanation."
                      }
                    </p>
                  </div>
                </>
              );
            })()}
          </div>
        </div>
      )}
    </div>
  );
};

export default MultipleChoiceQuestion;
